//import "./About.css";

const Extracurriculars = () => {
    return (
      <div className="page">
        <h1>Extracurriculars Me</h1>
        <p>This is the extracurriculars page.</p>
      </div>
    );
  };
  
  export default Extracurriculars;
  